<!-- @format -->

<div id="pdp-product-description">
	<hmf-accordion
		label="Product Information"
		size="large"
		[expandOverContent]="false"
		[active]="true"
		icon="list-bullet"
		(activeChange)="handleAccordionChanges($event)">
		<div class="full-long-description">
			<div class="description-body label-base">
				@if (isOOSProductDescription) {
					<ng-container *ngTemplateOutlet="descriptionBodyOOS"></ng-container>
					<ng-container *ngTemplateOutlet="readMore"></ng-container>
				} @else {
					<ng-container *ngTemplateOutlet="descriptionBody"></ng-container>
					<ng-container *ngTemplateOutlet="readMore"></ng-container>
				}
			</div>
		</div>
	</hmf-accordion>
</div>

<ng-template #descriptionBody>
	<ng-container *ngTemplateOutlet="infoSummaryDisplay"></ng-container>

	<ng-container *ngTemplateOutlet="sustainabilityIcons"></ng-container>

	<div
		class="description-text-wrapper"
		[class.abbreviated-description]="isAbbreviatedDescription"
		commonImagesLoaded
		(imagesLoaded)="imagesLoaded()">
		<div
			#descriptionText
			class="description-text"
			itemprop="description"
			[innerHTML]="product?.longDescription"></div>
		<ul
			#displayableAttributes
			class="displayable-desc-attrs">
			<li
				*ngFor="
					let descAttr of displayableDescriptiveAttributes;
					trackBy: trackByAttribute
				">
				<a
					class="protips-link"
					href="{{ descAttr.value }}"
					*ngIf="isProTipDisplayable && descAttr.name === 'DSG Pro Tips'"
					target="_blank"
					rel="noopener">
					{{ descAttr.name }}
				</a>
				<span *ngIf="descAttr.name !== 'DSG Pro Tips'">
					<span
						*ngIf="
							descAttr.name &&
								(descAttr.name.toLowerCase() === 'brand' ||
									descAttr.name.toLowerCase() === 'manufacturer');
							then brandDisplayableAttr;
							else standardDisplayableAttr
						"></span>
					<ng-template #brandDisplayableAttr>
						{{ descAttr.name }} : <span itemprop="brand">{{ descAttr.value }}</span>
					</ng-template>
					<ng-template #standardDisplayableAttr>
						{{ descAttr.name }} : {{ descAttr.value }}
					</ng-template>
				</span>
			</li>
		</ul>

		<div
			#propSixtyFive
			*ngIf="prop65Product.isprop65Product"
			class="prop65-warning-text">
			<span>
				<img
					src="assets/image/prop65warning.svg"
					alt="Product Warning"
					loading="lazy" />
				<strong>WARNING: </strong>
			</span>
			<span [innerHTML]="prop65Product.prop65warningtext"></span>
		</div>

		<ul
			#productNumbers
			class="list-reset product-numbers">
			<li>
				Web ID: <span itemprop="productID">{{ product?.partNumber }}</span>
			</li>
			<li *ngIf="resolvedSkuID && !isComingSoon">
				SKU: <span>{{ resolvedSkuID }}</span>
			</li>
		</ul>
	</div>
</ng-template>
<ng-template #readMore>
	@if (isAbbreviatedDescription === true) {
		<span
			id="product-description-read-more"
			hmf-action-text
			variant="tertiary"
			class="hmf-mt-m"
			(click)="onReadMoreClicked()">
			Read More
		</span>
	}
</ng-template>
<ng-template #descriptionBodyOOS>
	<ng-container *ngTemplateOutlet="infoSummaryDisplay"></ng-container>

	<div
		class="description-text-wrapper"
		[class.abbreviated-description]="isAbbreviatedDescription">
		<div class="description-text">
			<div
				#descriptionText
				itemprop="description"
				[innerHTML]="product?.longDescription"></div>
			<ul
				#displayableAttributes
				class="displayable-desc-attrs">
				<li
					*ngFor="
						let descAttr of displayableDescriptiveAttributes;
						trackBy: trackByAttribute
					">
					<a
						class="protips-link"
						href="{{ descAttr.value }}"
						*ngIf="descAttr.name === 'DSG Pro Tips'"
						target="_blank"
						rel="noopener">
						{{ descAttr.name }}
					</a>
					<span *ngIf="descAttr.name !== 'DSG Pro Tips'">
						<span
							*ngIf="
								descAttr.name &&
									(descAttr.name.toLowerCase() === 'brand' ||
										descAttr.name.toLowerCase() === 'manufacturer');
								then brandDisplayableAttr;
								else standardDisplayableAttr
							"></span>
						<ng-template #brandDisplayableAttr>
							{{ descAttr.name }} : <span itemprop="brand">{{ descAttr.value }}</span>
						</ng-template>
						<ng-template #standardDisplayableAttr>
							{{ descAttr.name }} : {{ descAttr.value }}
						</ng-template>
					</span>
				</li>
			</ul>
			<ul
				#productNumbers
				class="list-reset">
				<li>
					Web ID: <span itemprop="productID">{{ product?.partNumber }}</span>
				</li>
				<li *ngIf="resolvedSkuID && !isComingSoon">
					SKU: <span>{{ resolvedSkuID }}</span>
				</li>
			</ul>
		</div>
	</div>
</ng-template>

<ng-template #sustainabilityIcons>
	@if (
		sustainablityIconsEnabled && selectSustainabilityAttributes$ | async;
		as sustainabilityAttributes
	) {
		<div
			[ngClass]="{
				'hmf-grid hmf-mb-s': isMobile,
				'hmf-display-flex hmf-justify-content-between hmf-mb-m': !isMobile
			}">
			@for (attr of sustainabilityAttributes; track attr) {
				<span
					class="hmf-display-flex hmf-align-items-center"
					[ngClass]="{
						'hmf-mb-s hmf-col hmf-span-6': isMobile,
						'flex-1': !isMobile
					}">
					<img
						aria-hidden="true"
						loading="lazy"
						[alt]="'Icon representing ' + attr"
						[src]="'assets/image/' + attr.replaceAll(' ', '') + 'Icon.svg'"
						[class.sustainability-icon-mobile]="isMobile" />
					<span class="hmf-ml-xs label-base hmf-body-bold-s hmf-body-bold-lg-m">{{
						attr
					}}</span>
				</span>
			}
		</div>
	}
</ng-template>

<ng-template #infoSummaryDisplay>
	@if (infoSummary.length >= 2 && shouldShowInfoSummary) {
		@if (displayInfoSummaryIcon) {
			<div class="hmf-mb-s hmf-mb-m-l">
				<ng-container *ngTemplateOutlet="iconInfoSummary"></ng-container>
			</div>
		} @else {
			<div class="hmf-display-flex hmf-mb-s hmf-mb-lg-m">
				@for (attr of infoSummary; track attr; let i = $index) {
					<div
						class="hmf-text-align-center featured-spec"
						[ngClass]="{ 'divider-right': i < infoSummary.length - 1 }">
						<p class="hmf-subheader-s hmf-mb-xxxs">{{ attr.name }}</p>
						<h3 class="hmf-header-bold-xs hmf-header-bold-md-s">{{ attr.value }}</h3>
					</div>
				}
			</div>
		}
	}
</ng-template>

<ng-template #iconInfoSummary>
	<div
		class="product-details-container hmf-display-flex hmf-flex-wrap hmf-flex-m-nowrap hmf-justify-content-m-evenly">
		@for (attr of infoSummary; track trackByName($index, attr)) {
			<div
				class="product-detail hmf-display-flex hmf-align-items-center hmf-mb-s hmf-mb-m-0"
				[ngClass]="
					displayInfoSummaryIcon ? 'hmf-pl-m-s' : 'hmf-flex-column hmf-text-align-center'
				">
				@if (displayInfoSummaryIcon) {
					<img
						class="product-detail-image hmf-mr-xs"
						alt="{{ attr.name }} icon"
						src="./assets/image/{{ attr.icon }}"
						loading="lazy" />
				}

				<div>
					<p
						class="product-detail-header hmf-mb-0"
						[ngClass]="{
							'product-detail-header-icon label-base-subtle': displayInfoSummaryIcon
						}">
						{{ attr.name }}
					</p>
					<p class="product-detail-value hmf-mb-0 label-base">{{ attr.value }}</p>
				</div>
			</div>
		}
	</div>
</ng-template>
